import { getContext, setContext } from 'svelte';
import { ObjectStore } from '@utils/orm'; // Assuming these are the store types
import { browser } from '$app/environment';

function setWritableContext(key, value) {
  const unique_key = Symbol.for(key);
  return setContext(unique_key, value);
}

function getStore(key) {
  // Convert the string key to the corresponding symbol
  const symbolKey = Symbol.for(key);
  if (!symbolKey) {
    throw new Error(`Store with key "${key}" does not exist.`);
  }

  return getContext(symbolKey);
}

export function createInitializeStoresFunction(storeKeys, storeTypes) {
  return function (initialValues = {}) {
    const stores = {};

    for (const [key, StoreType] of Object.entries(storeTypes)) {
      const initialValue = StoreType === ObjectStore ? {} : [];

      stores[key] = StoreType(initialValues[key] || initialValue);
    }

    // Set each store in the context
    for (const [key, store] of Object.entries(stores)) {
      setWritableContext(storeKeys[key], store);
    }
  };
}

export function createGetStoreFunction(storeKeys, storeTypes) {
  return function (key) {
    let store = getStore(storeKeys[key]);

    if (!store) {
      const StoreType = storeTypes[key];
      if (!StoreType) {
        throw new Error(`No store type defined for key '${key}'`);
      }
      const initialValue = StoreType === ObjectStore ? {} : [];
      store = StoreType(initialValue); // Initialize with default values
      store.isInitialized = false;

      if (browser && window.APP_ENV === 'development') {
        // Wrap each method of the store in development mode
        Object.keys(store).forEach((prop) => {
          const originalProperty = store[prop];
          if (typeof originalProperty === 'function') {
            store[prop] = function (...args) {
              console.error(
                `Method ${prop} of STORE ${key} is being called on an uninitialized store. Initialize the store on the page if it should be reactive or add a null guard.`
              );
              return originalProperty.apply(this, args);
            };
          }
        });
      }
    }

    return store;
  };
}
